import Input from './Input';

export { InputType } from './Input';
export default Input;
